module.exports = __webpack_public_path__ + "static/media/signage-indoor-img30.b6c5c563.jpg";